// extracted by mini-css-extract-plugin
export default {"field":"styles_field__Bgh3A","label":"styles_label__26xUg"};